module.exports = __webpack_public_path__ + "static/img/IMG_20161120_154320.eadfb4e6.jpg";